import { useTranslation } from "@sagot/i18n";
import { Badge, Icon } from "@sagot/ui";
import { statusSpec, type ConversationItem } from "./inbox-model";

/** Status badge: dot + text + tone (never colour alone). */
export function ConversationStatusBadge({ item }: { item: Pick<ConversationItem, "needs_staff" | "status"> }) {
  const { t } = useTranslation();
  const spec = statusSpec(item);
  return (
    <Badge tone={spec.tone} dot>
      {t(`engage.inbox.status.${spec.key}`)}
    </Badge>
  );
}

/** Who is handling the conversation: AI, a staff member, or a team. */
export function AssigneeBadge({ item }: { item: Pick<ConversationItem, "assignee" | "ai_paused"> }) {
  const { t } = useTranslation();
  const { assignee } = item;
  if (assignee.type === "user" && assignee.name) {
    const first = assignee.name.split(/\s+/)[0] ?? assignee.name;
    return (
      <Badge tone="brand" data-assignee>
        <Icon name="headset" className="size-3" />
        {t("engage.inbox.list.staff", { name: first })}
      </Badge>
    );
  }
  if (assignee.type === "team") {
    return (
      <Badge tone="brand" data-assignee>
        <Icon name="users" className="size-3" />
        {assignee.name ?? t("engage.inbox.list.team")}
      </Badge>
    );
  }
  return (
    <Badge tone="neutral" data-assignee>
      <Icon name="bot" className="size-3" />
      {t("engage.inbox.list.ai")}
    </Badge>
  );
}
